import React, { useEffect, useMemo, useState } from 'react'
import { Table } from 'react-angle-dashboard-components'
import { ICensusForm } from './types'
import { CensusTableRow } from './CensusTableRow'
import InfiniteScroll from 'react-infinite-scroll-component'

const PAGE_SIZE = 100
function paginate(array: ICensusForm[], page_number: number) {
  return array.slice(page_number * PAGE_SIZE, (page_number + 1) * PAGE_SIZE)
}

export const CensusTable: React.FC<{
  rows: ICensusForm[]
}> = ({ rows }) => {
  const scrollParent = useMemo(
    () => document.getElementById('mainLayoutContainer'),
    []
  )
  const [currentPage, setCurrentPage] = useState(0)
  const [pagedRows, setPagedRows] = useState<ICensusForm[]>([])

  const hasMoreItems = useMemo(() => {
    const newPage = paginate(rows, currentPage + 1)
    return newPage.length > 0
  }, [rows, currentPage])

  useEffect(() => {
      setPagedRows(rows)
  }, [rows, currentPage, pagedRows.length])

  const loadFunc = () => {
    setCurrentPage((prev) => prev + 1)
    setPagedRows((prev) => [...prev, ...paginate(rows, currentPage + 1)])
  }

  return (
    <InfiniteScroll
      dataLength={pagedRows.length}
      next={loadFunc}
      hasMore={hasMoreItems}
      loader={<h5>Loading...</h5>}
      scrollableTarget={scrollParent}
    >
      <Table
        headerClassName="thead-light"
        headers={[
          { title: 'MEMBER NAME' },
          { title: 'DATE OF BIRTH' },
          { title: 'ZIP' },
          { title: 'RELATIONSHIP TO SUBSCRIBER' },
          { title: 'GENDER' },
          { title: 'TIER' },
          { title: 'PLAN' },
          { title: '' }
        ]}
      >
        <tbody>
          {pagedRows?.map((row: ICensusForm, i: number) => {
            return (
              <CensusTableRow
                row={row}
                key={`${row.firstName}-${row.lastName}-${i}`}
                rowIdx={i}
              />
            )
          })}
        </tbody>
      </Table>
    </InfiniteScroll>
  )
}
